import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Certification} from "../models/certification";
import {environment} from "../../../../environments/environment";
import {PageQueryInterface} from "../../../_models/page.interface";

@Injectable({
  providedIn: 'root',
})
export class CertService {
  private readonly CERT_API: string;

  constructor(private http: HttpClient) {
    this.CERT_API = `${environment.apiUrl}/cert/`;
  }

  async getCertifications(): Promise<any> {
    return await this.http.get(this.CERT_API + 'get-all').toPromise();
  }

  async getLimit(): Promise<any> {
    return await this.http.get(this.CERT_API + 'get-limit').toPromise();
  }

  async getLimitAdmin(id: number): Promise<any> {
    return await this.http.get(this.CERT_API + 'admin-get-limit/' + id).toPromise();
  }

  async getCertificationByProvider(provider: string): Promise<any> {
    let url = `${this.CERT_API}get-certifications-by-provider/${provider}`;
    return await this.http.get(url).toPromise();
  }

  async addCertification(certification: Certification): Promise<any> {
    return await this.http.post(this.CERT_API + 'add-certification', certification).toPromise();
  }

  async updateCertification(certification: Certification): Promise<any> {
    return await this.http.post(this.CERT_API + 'update-certification', certification).toPromise();
  }

  async deleteCertification(certification: Certification): Promise<any> {
    return await this.http.post(this.CERT_API + 'delete-certification', certification).toPromise();
  }

  async getAllPagedCertifications(pageQuery: PageQueryInterface): Promise<any> {
    return await this.http.post(this.CERT_API + `get-all-certifications`, pageQuery).toPromise();
  }
}
